import React from "react";
import {
  Skeleton,
  SkeletonTable,
  SkeletonCard,
  SkeletonStatsCard,
} from "../Skeleton";
import { cn } from "../../lib/utils";

interface ListPageSkeletonProps {
  showStats?: boolean;
  showFilters?: boolean;
  showViewToggle?: boolean;
  viewMode?: "card" | "table";
  statsCount?: number;
  className?: string;
}

export const ListPageSkeleton: React.FC<ListPageSkeletonProps> = ({
  showStats = true,
  showFilters = true,
  showViewToggle = false,
  viewMode = "card",
  statsCount = 4,
  className,
}) => {
  return (
    <div className={cn("min-h-screen", className)}>
      <div className="mx-auto">
        {/* Header */}
        <div className="mb-6 sm:mb-8">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
            <div className="flex-1">
              <Skeleton
                variant="text"
                width="60%"
                height={40}
                className="mb-2"
              />
              <Skeleton variant="text" width="40%" height={20} />
            </div>
          </div>

          {/* Stats Cards */}
          {showStats && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6">
              {Array.from({ length: statsCount }).map((_, i) => (
                <SkeletonStatsCard
                  key={i}
                  className="bg-linear-to-br from-tiber-500 to-tiber-600"
                />
              ))}
            </div>
          )}

          {/* Filters and Search */}
          {showFilters && (
            <div className="bg-white rounded-xl shadow-lg border border-tiber-600 p-4 sm:p-6 mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
                <div className="lg:col-span-2">
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={40}
                    className="rounded-lg"
                  />
                </div>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  className="rounded-lg"
                />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  className="rounded-lg"
                />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  className="rounded-lg"
                />
              </div>
            </div>
          )}

          {/* View Toggle */}
          {showViewToggle && (
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={36}
                  className="rounded-lg"
                />
              </div>
            </div>
          )}
        </div>

        {/* Content List */}
        {viewMode === "card" ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg border border-tiber-600 overflow-hidden p-8">
            <SkeletonTable rows={8} columns={5} />
          </div>
        )}
      </div>
    </div>
  );
};
